import { ListManipulation } from './listManipulation';

export class QueueManipulation{
    timestamp: number;
    manipulations: ListManipulation[];
}